export default "__VITE_ASSET__D_wv5ev5__"